import React from 'react';
import { InviteClientButton as Component, Props as ComponentProps } from './InviteClientButton';

export const InviteClientButton = (props: ComponentProps) => <Component {...props} />;
